// "Transaksi Saya": labels and shaping for GET /finance/my-transactions. The backend decides ownership; nothing is invented here.
export const KIND_LABELS = {
  package_purchase: "Pembelian paket", credit: "Kredit masuk", debit: "Pemakaian", reserve: "Reservasi kredit", settle: "Penyelesaian kredit",
  release: "Pelepasan reservasi", refund: "Pengembalian kredit", adjustment: "Penyesuaian", cancelled: "Dibatalkan",
};
export const STATUS_LABELS = {
  paid: "Berhasil", pending: "Menunggu", failed: "Gagal", expired: "Kedaluwarsa", refund: "Dikembalikan", rejected: "Ditolak",
  completed: "Selesai", cancelled: "Dibatalkan", other: "Lainnya",
};
export const kindLabel = (kind) => KIND_LABELS[kind] || "Transaksi lain";
export const statusLabel = (status) => STATUS_LABELS[status] || (status ? "Status lain" : "-");
// Only a PAID purchase adds credit; every other purchase status must not look like a credit increase.
export const creditText = (row) => {
  const credits = row?.credits;
  if (!Number.isInteger(credits)) return "-";
  if (row.kind === "package_purchase" && row.status !== "paid") return `${credits} kredit (belum masuk)`;
  return `${credits > 0 ? "+" : ""}${credits} kredit`;
};
export const amountText = (row) => (Number.isInteger(row?.amount_idr) ? `Rp${row.amount_idr.toLocaleString("id-ID")}` : "");
export const normalizeTransactions = (payload) => (Array.isArray(payload?.transactions) ? payload.transactions.filter((t) => t && typeof t.id === "string" && typeof t.kind === "string") : []);
export const KIND_FILTERS = [["", "Semua"], ["package_purchase", "Pembelian paket"], ["reserve", "Reservasi"], ["settle", "Penyelesaian"], ["release", "Pelepasan"], ["refund", "Pengembalian"], ["credit", "Kredit masuk"]];
export const filterTransactions = (rows, kind) => (kind ? rows.filter((r) => r.kind === kind) : rows);
